import { Button, Typography } from '@mui/material';
import {
  useUpdatePromptMutation,
} from 'api/services/dataEndpoints';
import { useState } from 'react';
import type { PromptType } from 'types/apiTypes/promptTypes';
import Input from 'components/Input';
import dayjs from 'dayjs';
import { StyledPaper } from './DataItem.styles';

type PromptsItemType = {
  prompt: PromptType;
};

const PromptItem: React.FC<PromptsItemType> = ({ prompt }) => {
  const [promptText, setPromptText] = useState<string>(prompt.prompt_text);
  const [btnDisabled, setBtnDisabled] = useState<boolean>(false);
  const [updatePrompt, { isLoading }] = useUpdatePromptMutation();

  const callUpdatePrompt = () => {
    updatePrompt({
      promptId: prompt.id,
      prompt: { prompt_text: promptText },
    }).finally(() => {
      setBtnDisabled(false);
    });
  };

  return (
      <StyledPaper elevation={3} className="prompt-item">
        <Typography variant="h5" sx={{ mb: 0.5, fontSize: '20px', fontWeight: 200 }}>Name: {prompt.name}</Typography>
        <Typography variant="h6" sx={{ fontSize: '16px', fontWeight: 200 }}>Updated at: {dayjs(prompt.updated_at).format('YYYY/MM/DD HH:mm')}</Typography>
        <Typography variant="h6" sx={{ mb: 0.5, fontSize: '16px', fontWeight: 200 }}>Updated by: {prompt.updated_by?.email}</Typography>
        <Input
          nameInput={`prompt-${prompt.id}`}
          label="Your prompt"
          value={promptText}
          onChangeValue={(e) => setPromptText(e.target.value)}
          multiline
          className="m10-0"
          />
        <div>
          <Button
            variant="contained"
            color="primary"
            disabled={btnDisabled || isLoading}
            onClick={() => callUpdatePrompt()}
          >{isLoading ? 'Updating...' : 'Update'}
          </Button>
        </div>
      </StyledPaper>
  );
};

export default PromptItem;
